export const FLAG_GETTING_USERS = 'FLAG_GETTING_USERS';
export const GET_USERS = 'GET_USERS';
export const CLEAR_USERS = 'CLEAR_USERS';
export const FLAG_USER_ACTIVITY = 'FLAG_USER_ACTIVITY';
export const GET_USER = 'GET_USER';
export const CLEAR_USER = 'CLEAR_USER';
export const GET_EXISTING_USER = 'GET_EXISTING_USER';
export const CLEAR_EXISTING_USER = 'CLEAR_EXISTING_USER';
